// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  notificationsCount: 15,
  production: false,
  purchaseLink: 'https://promsys.thrivecart.com/bar-helper-copy-3/',
  reCaptchaKey: '6LehhfgoAAAAAMFcJ9uMa3msGYP1Enqb1DsoYfNg',
  firebase: {
    apiKey: "AIzaSyBnrViARu7CDh99DYW33wYYj6Isk34FV8A",
    authDomain: "barhelper-5d620.firebaseapp.com",
    databaseURL: "https://barhelper-5d620.firebaseio.com",
    projectId: "barhelper-5d620",
    storageBucket: "barhelper-5d620.appspot.com",
    messagingSenderId: "690295987921",
    appId: "1:690295987921:web:18a03c88c1ecbea1792ff0",
    measurementId: "G-FEGJ8K0RRC",
    vapidKey: 'BPPPbP_ReGiTspA4C8e7kFxr5u3kFZ67ydvnU0_xkDt1fvLnk_XPcUPugxORhZcn3vUnIos3hJrvd4IW5C0xuI4'
  },
  signon: {
    google: {
      webClientId: 'YOUR-2024-WEB-CLIENT-ID.apps.googleusercontent.com', // Replace with your Web OAuth Client ID from 2024
      androidClientId: '1031783853634-j1m83ane3jroi4nllpg51amss36v80es.apps.googleusercontent.com', // For Android
      iosClientId: '1031783853634-sqoe5ad5b3aq7bag0r2tl0tlu65rku13.apps.googleusercontent.com'  //For ios
    },
    facebook: {
      appId: '2887832644610013', // Facebook App ID
      clientToken: '8bab94ce0f303ab02fd240bc083af082' // Facebook Client Token
    },
    apple: {
      serviceId: 'app.barhelper.signon',
      redirectUrl: 'https://europe-west1-barhelper-5d620.cloudfunctions.net/appleLoginCallback',
    },
  },


  untappd: {
    // The client secret lives server-side only (UNTAPPD_CLIENT_SECRET secret,
    // used by getUntappdAuthTokenRequest) — never put it in these files.
    clientId: '4E9D784DA72CA65615E0634F84C0278B711D8755',
    redirectUrl: 'https://stage.barhelper.app/settings/untappd',
    authenticateUrl: 'https://untappd.com/oauth/authenticate/?client_id=' +
      '4E9D784DA72CA65615E0634F84C0278B711D8755' +
      '&response_type=code&redirect_url=https://stage.barhelper.app/settings/untappd'
  }, sentry: {
    dsn: 'https://07af8afc623a403a93daa94b692a945b@o413889.ingest.sentry.io/5302446',
    disableLogging: false,
    projectName: 'barhelper-stage'
  },
  onTapTvUrl: 'https://stage.tv.barhelper.app',
  onTap2TvUrl: 'https://stage.ontap.barhelper.app/tv',
  plaatoServerIp: '9.163.64.255',
  plaatoApiServer: 'https://plaatoweb.barhelper.app',
  plaatoDebugApiKey: 'bh-plaato-debug-7kQp2mXr',
  revenueCat: {
    appleApiKey: 'appl_koOyFnSOxKyyOwYHrPFjYUViSYg',
    googleApiKey: 'goog_FrPsPOYUKciwxkYhHvDTGbeYAcG',
    entitlementId: 'Premium'
  }
};

